import {FC} from 'react'
import {useIntl} from 'react-intl'
import {Link} from 'react-router-dom'
import {allowTestOnly} from '../../../helpers'
import {useAuth} from '../../../providers'

const AsideUserMenu: FC = () => {
  const intl = useIntl()
  const {currentUser} = useAuth()

  return (
    <div className='d-flex flex-column' style={{minWidth: '230px'}}>
      {/* begin::Header */}
      <div className='bg-primary px-5 py-4'>
        <div className='d-flex align-items-center'>
          <span className='text-white fs-6 fw-bolder lh-1'>{currentUser?.name}</span>
        </div>
        {allowTestOnly(currentUser) && (
          <div className='mt-2'>
            <span className='text-white fs-8 fw-semibold opacity-75'>
              {intl.formatMessage({id: 'CURRENT_VERSION'})}: #{process.env.REACT_APP_COMMIT_ID}
            </span>
          </div>
        )}
      </div>
      {/* end::Header */}

      {/* begin::Body */}
      <div className='bg-white px-5 py-3'>
        <Link
          to='/profile'
          className='d-flex align-items-center text-gray-700 text-hover-primary fw-semibold fs-7 py-2 text-decoration-none'
        >
          {intl.formatMessage({id: 'PROFILE'})}
        </Link>
        <div className='separator my-1' />
        <Link
          to='/logout'
          className='d-flex align-items-center text-gray-700 text-hover-danger fw-semibold fs-7 py-2 text-decoration-none'
        >
          {intl.formatMessage({id: 'SIGN_OUT'})}
        </Link>
      </div>
      {/* end::Body */}
    </div>
  )
}

export {AsideUserMenu}
